import * as React from 'react';
import { SVGProps } from 'react';

const IconPipetteSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3s2.5-2.5 5 0 0 5 0 5l-3.5 3.5L20 14a1.414 1.414 0 0 1-2 2l-2.5-2.5-5.006 5.006-.31.302c-1.524 1.436-3.395 2.563-5.467 2.588l-.215-.002c-.66-.017-1.23-.122-1.502-.394-.237-.237-.348-.703-.383-1.258l-.01-.243c-.054-2.158 1.1-4.106 2.586-5.682l.301-.31L10.5 8.5 8 6a1.414 1.414 0 0 1 2-2l2.5 2.5L16 3ZM6.908 14.92c-1.453 1.454-2.317 2.994-2.302 4.474 1.48.015 3.02-.848 4.474-2.302l5.006-5.006-2.172-2.172-5.006 5.006Z"
    />
  </svg>
);
export default IconPipetteSizeM;
